import httpRequest from '@/utils/request.js'

/**
 * @module监测模块接口
 * @GET
 * @param {*} params 传递的参数
 *
 */
export const chartStatistic = (params = {}) => httpRequest.httpGet({
    url: '/service/cs/chartStatistic', params: {
      ...params
    }
  })

export const monitorInstance = (params = {}) => httpRequest.httpGet({
    url: '/service/monitorInstance/lst', params: {
      ...params
    }
  })

export const setHomeShowInstance = (id) => httpRequest.httpPut(`/service/monitorInstance/setHomeShowInstance?id=${id}`)

export const getConfig = (params = {}) => httpRequest.httpGet({
    url: '/service/monitorInstance/getConfig', params: {
      ...params
    }
  })
export const carrierdata = (params = {}) => httpRequest.httpGet({
    url: '/service/monitorInstance/carrier/lst', params: {
      ...params
    }
  })

export const getSensor = (params = {}) => httpRequest.httpGet({
    url: '/service/monitorInstance/getSensor', params: {
      ...params
    }
  })

export const refresh = (params = {}) => httpRequest.httpGet({
    url: '/service/gm/refresh', params: {
      ...params
    }
  })
export const listTree = (params = {}) => httpRequest.httpGet({
    url: '/service/gm/tree', params: {
      ...params
    }
  })

// 地图
export const mapNode = (params = {}) => httpRequest.httpGet({
    url: '/service/dm/map', params: {
      ...params
    }
  })
export const detailcsd = (params = {}) => httpRequest.httpGet({
    url: '/service/dm/csd', params: {
      ...params
    }
  })
export const mpDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/dm/mpDetail', params: {
      ...params
    }
  })
export const allNode = (params = {}) => httpRequest.httpGet({
    url: '/service/scene/allNode', params: {
      ...params
    }
  })
export const mapSpwtime = (params = {}) => httpRequest.httpGet({
    url: '/service/dm/refresh', params: {
      ...params
    }
  })

  /**
* @POST
* @param {*} params
*
*/

export const saveInstance = (data, loadingOptions) => httpRequest.httpPost('/service/monitorInstance/save', data, loadingOptions)
export const monitorList = (data, loadingOptions) => httpRequest.httpPost('/service/gm/gd', data, loadingOptions)

export const deleteInstance = (data, loadingOptions) => httpRequest.httpdelete('/service/monitorInstance/del', data, loadingOptions)
